export function generateTimestamp() {
    return new Date()
        .toISOString()
        .replaceAll(/[:TZ.-]/g, "")
        .substring(2, 14);
}
